import { ViewOptionPlan, isLivePlan } from '../viewOptions';

export interface EntradaAterrizaje {
	/** `GET /users/plans`. `undefined` es «aún no ha llegado», no «sin planes». */
	plans: ViewOptionPlan[] | undefined;
	/** Plan individual en proceso: alta del funnel viva sin plan personal todavía. */
	pendingPersonalPlan: boolean;
}

/**
 * ¿Aterriza en el Resumen multicuenta? (product#6, §3.1). Cuentan los planes vivos (no archivados;
 * un suspendido sí, tiene dinero que mirar) y el plan personal en proceso (decisión de Marisa,
 * 16/10/26). Con 2 o más, sí; con 1, el comportamiento de siempre.
 *
 * Mientras no han llegado los planes no se decide nada: aterrizar por adelantado obligaría a
 * deshacer la vista en cuanto llegue la lista.
 */
export function aterrizaEnResumen({ plans, pendingPersonalPlan }: EntradaAterrizaje): boolean {
	if (!plans) return false;
	return plans.filter(isLivePlan).length + (pendingPersonalPlan ? 1 : 0) >= 2;
}
